import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import {
  Container,
  Col,
  Button,
  Modal,
  Form,
  Spinner,
  Row,
} from "react-bootstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import useFinanceApi from "../../services/financeApi";
import { toast } from "react-toastify";
import { GetCurrentUserName } from "../../utils/permissionChecker";
import BasicTable from "../../components/UiComponent/basicTable";
const Expense_category = () => {
  const { t } = useTranslation();
  const loggedInUser = GetCurrentUserName();
  const { get_expense_catagory, addExpenseCatagory, updateExpenseCatagory } =
    useFinanceApi();
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [CategoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const RegisterMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await updateExpenseCatagory(newData);
      } else {
        result = await addExpenseCatagory(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_expense_catagory");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const getExpenseQuery = useQuery(["get_expense_catagory"], () =>
    get_expense_catagory()
  );
  const dataTest = useMemo(() => {
    const data = getExpenseQuery.data?.data?.expense_catagory || [];
    return data.map((item, index) => ({ ...item, rowNumber: index + 1 }));
  }, [getExpenseQuery.data]);
  if (getExpenseQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getExpenseQuery.isError) {
    return <div>Error: {getExpenseQuery.error.message}</div>;
  }
  const handleEdit = (event, rowItem) => {
    event.preventDefault();
    setCategoryName(rowItem.row.original.name);
    setDescription(rowItem.row.original.description);
    setCategoryId(rowItem.row.original.id);
    setIsUpdateMode(true);
    handleShowModal();
  };

  const paymentMethodColumns = [
    {
      header: "#",
      accessorKey: "rowNumber",
    },
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Description",
      accessorKey: "description",
    },
    {
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => handleEdit(e, row)}
          >
            {t("update")}
          </Button>
        </div>
      ),
    },
  ];

  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
    setCategoryName("");
    setDescription("");
    setCategoryId("");
    setFormError("");
  };
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    let formData;
    if (!CategoryName || !description) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    if (isUpdateMode) {
      formData = {
        id: categoryId,
        description: description,
        name: CategoryName,
        updated_by: loggedInUser,
      };
    } else {
      formData = {
        description: description,
        name: CategoryName,
        updated_by: loggedInUser,
        created_by: loggedInUser,
      };
    }
    try {
      setIsSubmitting(true);
      await RegisterMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Container fluid>
      <BasicTable
        data={dataTest}
        columns={paymentMethodColumns}
        title={"Expenses Categories"}
        actionButton={
          <Button
            variant="btn btn-info btn-sm m-2"
            onClick={() => handleShowModal()}
          >
            {t("add_expense_category")}
          </Button>
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode
              ? "Update the expense category"
              : "Register new expense category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label className="text-secondary">
                    {t("expense_category")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=" Enter expense category"
                    value={CategoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button variant="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              variant="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Update" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Expense_category;
